import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'
import { URL_SERVICIOS_LOCALES, URL_SERVICIOS_AWS,NUBE_AWS, URL_DIAN_CREAR_SET_PRUEBA, URL_DIAN_DOCUMENTO, URL_DIAN_RESUMEN_SUSCRIPTOR, URL_DIAN_PDF, DEETDMRCSP_POS_URL_CREAR_SET_PRUEBA, DEETDMRCSP_POS_URL_DIAN_DOCUMENTO } from '../../config/url.servicio'

@Injectable()
export class DianProvider {
    token:string
    urlPrintService:string
    companiaId:number
    usuarioId: number;

    constructor(public http: Http, private storage:Storage) {
        this.storage.get('token').then((val) => {
            this.token = val
        });

        this.storage.get('companiasId').then((val) => {
            this.companiaId = val
        })

        this.storage.get('urlPrint').then((val) => {
            this.urlPrintService = val
        });

        this.storage.get('usuariosId').then((usuario) => {
            this.usuarioId = usuario
        });

    }

    buscarParametrosCaja() {
      if(NUBE_AWS) {
        console.log('nube_aws')
        } else {
        console.log('no es nube_aws')
      }
    }
    buscarVentasFacturaElectronica (id:any, clienteId: any, fechaInicio: any, fechaFinal: any){
        const url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS;
        if(NUBE_AWS) {
          let data = {
            name: "buscarVentasFacturaElectronica",
            parameters : {companiasId: id, clienteId,fechaInicio,fechaFinal }
          }
          let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http
              .post(`${url}/procedure`, data, options)
        } else {
          let headers = new Headers({
              'Content-Type': 'application/json',
              'authorization': 'Bearer ' + this.token
          })

          let options = new RequestOptions({
              headers: headers
          })

          const datos = {
              "companiasId":id,
              "clienteId": clienteId,
              "fechaInicio": fechaInicio,
              "fechaFinal": fechaFinal
              }

          return this.http
              .post(`${url}/proceso/buscarVentasFacturaElectronica`, datos, options)
        }
    }

    async buscarVentasFacturaElectronicaGeneradas (companiasId :any, factura: any): Promise<any> {

              let promise = new Promise((resolve,reject)=> {
                const url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS;
                let data = {
                       name: "buscarVentasFacturaElectronicaGeneradas",
                       parameters : {companiasId: companiasId, factura:factura }
                     }
                     let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
                     let options = new RequestOptions({ headers: headers }) // Create a request option
                      this.http
                     .post(`${url}/procedure`, data, options).subscribe((data)=> {
                        return resolve(data)
                     }, (error) => {
                        return reject(error)
                     })
               })

               return promise
    }

    async buscarVentasFacturaElectronicaGeneradasPOS (companiasId :any, factura: any): Promise<any> {

      let promise = new Promise((resolve,reject)=> {
        const url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS;
        let data = {
               name: "buscarVentasFacturaElectronicaGeneradasPOS",
               parameters : {companiasId: companiasId, factura:factura }
             }
             let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
             let options = new RequestOptions({ headers: headers }) // Create a request option
              this.http
             .post(`${url}/procedure`, data, options).subscribe((data)=> {
                return resolve(data)
             }, (error) => {
                return reject(error)
             })
       })

       return promise
}

    async devolverCompania (): Promise<any> {

      let promise = new Promise((resolve,reject)=> {
        this.storage.get('companiasId').then((companiasId)=>{
                return resolve(companiasId)
             }, () => {
                return reject(undefined)
             })
       })

       return promise
}


    devolverDatosFacturaElectronica(factura: any, setPruebasFacturaElectronica: boolean) {
      const url = Number(setPruebasFacturaElectronica) ? URL_DIAN_CREAR_SET_PRUEBA : URL_DIAN_DOCUMENTO

      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Basic OTAwMzk1MjUyOnR1ZmFjdHVyYS5jb0Bzb2Z0d2FyZWVzdHJhdGVnaWNvLmNvbQ=='
      })

      let options = new RequestOptions({
          headers: headers
      })

      console.log('datos factura', factura)
      let data = JSON.stringify(factura)

      return this.http.post(`${url}`, data, options).map((data) =>
      { console.log('data json', data)
        return data.json()}
      )
        }

        devolverDatosFacturaElectronicaResumenSuscriptor(suscriptor: string) {
            const url = URL_DIAN_RESUMEN_SUSCRIPTOR

            let headers = new Headers({
                'Content-Type': 'application/json',
                'authorization': 'Basic OTAwMzk1MjUyOnR1ZmFjdHVyYS5jb0Bzb2Z0d2FyZWVzdHJhdGVnaWNvLmNvbQ=='
            })

            let options = new RequestOptions({
                headers: headers
            })

            return this.http.get(`${url}${suscriptor}`, options).map((data) =>
            { console.log('data json', data)
              return data.json()}
            )
            }

            devolverPdfFacturaElectronica(id: string) {
              const url = URL_DIAN_PDF

              let headers = new Headers({
                  'Content-Type': 'application/json',
                  'authorization': 'Basic OTAwMzk1MjUyOnR1ZmFjdHVyYS5jb0Bzb2Z0d2FyZWVzdHJhdGVnaWNvLmNvbQ=='
              })

              let options = new RequestOptions({
                  headers: headers
              })

              return this.http.get(`${url}${id}`, options).map((data) =>
              { console.log('data json', data)
                return data.json()}
              )
              }

            devolverDatosFacturaElectronicaResumenSuscriptorPorCompania(companiasId: any, ambientePrueba: string) {
                const url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS;
                if(NUBE_AWS) {
                  let data = {
                    name: "buscarConsecutivosFacturacionDian",
                    parameters : {companiasId, ambientePrueba }
                  }
                  let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
                  let options = new RequestOptions({ headers: headers })
                  return this.http
                      .post(`${url}/procedure`, data, options)
                } else {
                  let headers = new Headers({
                      'Content-Type': 'application/json',
                      'authorization': 'Bearer ' + this.token
                  })

                  let options = new RequestOptions({
                      headers: headers
                  })

                  const datos = {
                      "companiasId":companiasId,
                      "ambientePrueba": ambientePrueba
                      }

                  return this.http
                      .post(`${url}/proceso/buscarConsecutivosFacturacionDian`, datos, options)
                }
                }

                updateConsecutivosFacturacionDian(companiasId: any, ambientePrueba: string, consecutivoAtual: Number) {
                    const url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS;
                    if(NUBE_AWS) {
                      let data = {
                        name: "updateConsecutivosFacturacionDian",
                        parameters : {companiasId, ambientePrueba,consecutivoAtual }
                      }
                      let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
                      let options = new RequestOptions({ headers: headers })
                      return this.http
                          .post(`${url}/procedure`, data, options)
                    } else {
                      let headers = new Headers({
                          'Content-Type': 'application/json',
                          'authorization': 'Bearer ' + this.token
                      })

                      let options = new RequestOptions({
                          headers: headers
                      })

                      const datos = {
                          "companiasId":companiasId,
                          "ambientePrueba": ambientePrueba,
                          "consecutivoAtual": consecutivoAtual
                          }

                      return this.http
                          .post(`${url}/proceso/updateConsecutivosFacturacionDian`, datos, options)
                    }
                    }
                    buscarVentasPosElectronica (companiasId:any, factura: any){
                      const url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS;
                      if(NUBE_AWS) {
                        let data = {
                          name: "buscarVentasPosElectronica",
                          parameters : {companiasId: companiasId, factura:factura }
                        }
                        let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
                        let options = new RequestOptions({ headers: headers }) // Create a request option
                        return this.http
                            .post(`${url}/procedure`, data, options)
                      } else {
                      }
                  }

                  buscarVentasPosElectronicodeetdmrcs (companiasId:any, factura: any){
                    const url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS;
                    if(NUBE_AWS) {
                      let data = {
                        name: "buscarVentasPosElectronicodeetdmrcs",
                        parameters : {companiasId: companiasId, factura:factura }
                      }
                      let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
                      let options = new RequestOptions({ headers: headers }) // Create a request option
                      return this.http
                          .post(`${url}/procedure`, data, options)
                    } else {
                    }
                }


                  devolverDatosPosElectronica(factura: any, setPruebasFacturaElectronica: boolean) {
                    const url = Number(setPruebasFacturaElectronica) ? DEETDMRCSP_POS_URL_CREAR_SET_PRUEBA : DEETDMRCSP_POS_URL_DIAN_DOCUMENTO

                    let headers = new Headers({
                        'Content-Type': 'application/json',
                        'authorization': 'Basic OTAwMzk1MjUyOnR1ZmFjdHVyYS5jb0Bzb2Z0d2FyZWVzdHJhdGVnaWNvLmNvbQ=='
                    })

                    let options = new RequestOptions({
                        headers: headers
                    })

                    console.log('datos factura', factura)
                    let data = JSON.stringify(factura)

                    return this.http.post(`${url}`, data, options).map((data) =>
                    { console.log('data json', data)
                      return data.json()}
                    )
                      }

                      updateConsecutivosPosDian(companiasId: any, ambientePrueba: string, consecutivoAtual: Number) {
                        const url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS;
                        if(NUBE_AWS) {
                          let data = {
                            name: "updateConsecutivosPosDian",
                            parameters : {companiasId, ambientePrueba,consecutivoAtual }
                          }
                          let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
                          let options = new RequestOptions({ headers: headers })
                          return this.http
                              .post(`${url}/procedure`, data, options)
                        } else {
                          let headers = new Headers({
                              'Content-Type': 'application/json',
                              'authorization': 'Bearer ' + this.token
                          })

                          let options = new RequestOptions({
                              headers: headers
                          })

                          const datos = {
                              "companiasId":companiasId,
                              "ambientePrueba": ambientePrueba,
                              "consecutivoAtual": consecutivoAtual
                              }

                          return this.http
                              .post(`${url}/proceso/updateConsecutivosFacturacionDian`, datos, options)
                        }
                        }


      buscarCufe (companiasId:any,factura:any){
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarCufe",
          parameters : {companiasId:companiasId, factura:factura}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http.post(`${url_servicio}/procedure`, data, options);
  }


  async calcularIca(companiasId :any, factura: any): Promise<any> {

    let promise = new Promise((resolve,reject)=> {
      const url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS;
      let data = {
             name: "calcularIca",
             parameters : {companiasId: companiasId, factura:factura }
           }
           let headers = new Headers({ 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.token }) // ... Set content type to JSON
           let options = new RequestOptions({ headers: headers }) // Create a request option
            this.http
           .post(`${url}/procedure`, data, options).subscribe((data)=> {
              return resolve(data)
           }, (error) => {
              return reject(error)
           })
     })

     return promise
}

}



// WEBPACK FOOTER //
// ./src/providers/dian/dian.ts